import React, { FunctionComponent } from 'react';
import { SbBlokData, storyblokEditable } from '@storyblok/react';

import { Logo } from '@savebetter/components';

import { MediaProps } from './Media';
import { PageSectionProps } from './PageSection';

interface Blok extends SbBlokData {
  media: MediaProps[];
}

interface HeaderImageProps extends PageSectionProps {
  blok: Blok;
}

export const HeaderImage: FunctionComponent<React.PropsWithChildren<HeaderImageProps>> = ({ blok }) => {
  const { media = [] } = blok;

  return (
    <div {...storyblokEditable(blok)}>
      {media.length > 0 && (
        <Logo
          src={media[0].img}
          alt={media[0].alt}
          size={{ sm: media[0].mobile || 'sm', md: media[0].tablet || 'md', lg: media[0].desktop || 'lg' }}
          className="my-2"
        />
      )}
    </div>
  );
};
